<template>
  <div class="home-ToDo">
     <a-spin tip="加载中" :spinning="data.loading">
      <a-tabs :animated="false" @tabClick="tabClick">
        <a-tab-pane
          v-for="(item, index) in data.tabs"
          :key="index"
          :tab="`${item.name}(${item.total})`"
        ><!----></a-tab-pane>
      </a-tabs>
      <vxe-table :data="data.list" height="396">
        <vxe-column field="billCode" title="单号" width="250">
          <template #default="{ row }">
            <router-link :to="row.path ? { path: row.path, query: row.query } : row.jumpLink">{{row.billCode}}</router-link>
          </template>
        </vxe-column>
        <vxe-column field="reason" title="事由"><!----></vxe-column>
        <vxe-column
          field="totalAmount"
          title="总金额"
          align="right"
          :formatter="formatCurrency"
        />
        <vxe-column field="billStatus" title="状态" width="200"><!----></vxe-column>
        <vxe-column field="appName" title="应用" width="200"><!----></vxe-column>
        <template #empty>
          <span>
            <img src="../images/empty.svg" />
            <p>暂无数据</p>
          </span>
        </template>
      </vxe-table>
      <div class="page-right">
        <a-pagination
          v-model="page.pageNo"
          size="small"
          :pageSizeOptions="pageSizeOptions"
          :pageSize="page.pageSize"
          :total="data.totalSize"
          showSizeChanger
          class="page-pagination"
          @showSizeChange="doChagePage"
          @change="doChagePage"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
        <div class="page-jump">
          <span class="jump-font jump-active">跳至</span>
          <a-input-number v-model="jumpPageNo" :precision="0" :min="1" :max="999" class="jump-input" />
          <a-button class="jump-btn" @click="doJumPage">Go</a-button>
        </div>
      </div>
     </a-spin>
  </div>
</template>
<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      pageSizeOptions: ['10', '20', '50', '100', '200', '500', '1000'],
      jumpPageNo: '',
      page: {
        pageNo: 1,
        pageSize: 20,
        subsystemCode: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$emit('load', this.page)
    },
    tabClick(value) {
      const { code } = this.data.tabs[value]
      this.page.subsystemCode = code
      this.loadData()
    },
    // 改变当前每页条数
    doChagePage(current, pageSize) {
      this.page.pageNo = current > 0 ? current : 1
      this.page.pageSize = pageSize
      this.loadData()
    },
    doJumPage() {
      const { jumpPageNo } = this
      this.jumpPageNo = ''
      this.doChagePage(jumpPageNo, this.page.pageSize)
    },
    formatCurrency({ cellValue }) {
      if (cellValue == null || cellValue === '') return '¥0.00'
      const num = Number(cellValue)
      return '¥' + num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>
<style lang="less" scoped>
.home-ToDo {
  /deep/ .ant-tabs-bar {
    border-bottom: none;
    margin-bottom: 8px;
    .ant-tabs-tab-active {
      background: #fafafa;
    }
    .ant-tabs-tab {
      margin: 0;
    }
  }
  .page-right {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    .page-pagination {
      flex-direction: row;
    }
    /deep/ .ant-select-selection--single{
      font-size: 12px;
    }
    .page-jump {
      flex-direction: row;
      display: flex;
      align-items: center;
      .jump-font {
        font-size: 12px;
        color: rgba(51, 51, 51, 0.85);
        opacity: 0.8;
      }
      .jump-btn {
        height: 24px;
        font-size: 12px;
        color: rgba(51, 51, 51, 0.85);
        opacity: 0.8;
        margin-left: 8px;
      }
      .jump-active {
        margin-left: 10px;
      }
      .jump-input {
        width: 50px;
        height: 24px;
        margin: 0 8px;
        /deep/ .ant-input-number-input{
          height: auto;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
